var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTheHierophant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 378.53 457.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke-width: 4px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #fff200;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 188.47,
    y1: 17.2,
    x2: 188.47,
    y2: 440.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.2,
    y1: 266.09,
    x2: 361.33,
    y2: 266.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 341.33,
    y1: 173.13,
    x2: 37.2,
    y2: 173.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.2,
    y1: 80.17,
    x2: 281.33,
    y2: 80.17
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "203.64 455.73 188.47 448.76 173.31 455.73 180.28 440.57 173.31 425.4 188.47 432.37 203.64 425.4 196.66 440.57 203.64 455.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "203.64 32.37 188.47 25.4 173.31 32.37 180.28 17.2 173.31 2.04 188.47 9.01 203.64 2.04 196.66 17.2 203.64 32.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "112.37 95.33 97.2 88.36 82.04 95.33 89.01 80.17 82.04 65 97.2 71.97 112.37 65 105.4 80.17 112.37 95.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "52.37 188.29 37.2 181.32 22.04 188.29 29.01 173.13 22.04 157.96 37.2 164.94 52.37 157.96 45.4 173.13 52.37 188.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "32.37 281.26 17.2 274.28 2.04 281.26 9.01 266.09 2.04 250.92 17.2 257.9 32.37 250.92 25.4 266.09 32.37 281.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "296.49 95.33 281.33 88.36 266.16 95.33 273.13 80.17 266.16 65 281.33 71.97 296.49 65 289.52 80.17 296.49 95.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "356.49 188.29 341.33 181.32 326.16 188.29 333.13 173.13 326.16 157.96 341.33 164.94 356.49 157.96 349.52 173.13 356.49 188.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "376.49 281.26 361.33 274.28 346.16 281.26 353.13 266.09 346.16 250.92 361.33 257.9 376.49 250.92 369.52 266.09 376.49 281.26"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheHierophant);
export default __webpack_public_path__ + "static/media/TheHierophant.45678f0735ce1818d7f2f99d10b2d6ec.svg";
export { ForwardRef as ReactComponent };